import { inject, Injectable } from '@angular/core';
import { Store } from '@sama/app-state';
import { ShapeState2D } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { getShapeHelper } from '../shape-helpers/get-shape-helper';
import { AbstractSensorContentStore2D } from '../state/abstract-sensor-content-store-2d';
import { LocationHelper } from './location-helper';

@Injectable()
export class ShapeBoundingPointsService {
  private store = inject(AbstractSensorContentStore2D);
  private locationHelper = new LocationHelper(this.store);

  getBoundingPoints(shapeStore: Store<ShapeState2D>) {
    const location = this.locationHelper.determineLocation(
      shapeStore.state().key_locations,
      this.store.state().frameNumber,
    );

    if (location.visibility <= 0 || location.points.length < 1) {
      return undefined;
    }

    return getShapeHelper(shapeStore.state().type).getBoundingPoints(
      location.points,
    );
  }
}
